import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SocketProvider } from './context/SocketContext';
import LandingPage from './pages/LandingPage';
import PreferencesPage from './pages/PreferencesPage';
import ChatPage from './pages/ChatPage';
import CommunityPage from './pages/CommunityPage';
import AdminPage from './pages/AdminPage';
import MainLayout from './components/layout/MainLayout';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

import './App.css';
import AboutPage from './pages/AboutPage';
import ContactUs from './pages/ContactPage';
import CommunityGuidelinesPage from './pages/CommunityGuidelinesPage';
import HelpFAQPage from './pages/HelpFaqPage';

const App = () => {
  return (
    <SocketProvider>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="/preferences" element={<PreferencesPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        <Route path='/communityGuide' element={<CommunityGuidelinesPage/>}/>
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/helpfaq" element={<HelpFAQPage />} />

        </Route>
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </SocketProvider>
  );
};

export default App;
